import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import { COMPANY_ADDRESS } from '../config';
import '../css/AboutPage.css';

const requisites = [
    { label: 'Повна назва', value: 'ФОП Фігура Тетяна Богданівна' },
    { label: 'ЄДРПОУ / РНОКПП', value: '2586412525' },
    { label: 'Форма власності', value: 'Фізична особа — підприємець (ФОП)' },
    { label: 'IBAN', value: 'UA493052990000026009041032053' },
    { label: 'Банк', value: 'АТ КБ "ПРИВАТБАНК"' },
    { label: 'МФО', value: '305299' },
    { label: 'Юридична адреса', value: COMPANY_ADDRESS },
];

const AboutPage = () => {
    return (
        <Layout>
            <SEO
                title="Про нас — Union Auto"
                description="Union Auto — продаж нових і б/у автозапчастин з Європи для популярних марок автомобілів. Дізнайтеся більше про нашу компанію."
                canonical="/about"
            />
            <div className="about-page">

                <section className="about-hero">
                    <h1 className="about-hero__title">Про нас</h1>
                    <p className="about-hero__subtitle">
                        <strong>Union Auto</strong> — інтернет-магазин б/в автомобільних запчастин з Європи. Ми допомагаємо підібрати потрібні деталі для різних марок автомобілів для ремонту та обслуговування авто.
                    </p>
                    <p className="about-hero__subtitle">
                        Ми прагнемо забезпечити зручний підбір запчастин, актуальну інформацію про товари та зрозумілий сервіс для клієнтів. Якщо вам потрібна консультація або допомога з підбором деталей, зв'яжіться з нами через контакти на сайті.
                    </p>
                </section>

                <section className="about-section">
                    <h2 className="about-section__title">Виписка з ЄДР</h2>
                    <div className="about-edr">
                        <a href="/docs/edr1.png" target="_blank" rel="noopener noreferrer" className="about-edr__item">
                            <img src="/docs/edr1.png" alt="Виписка з ЄДР — сторінка 1" className="about-edr__img" />
                            <span className="about-edr__caption">Сторінка 1</span>
                        </a>
                        <a href="/docs/edr2.png" target="_blank" rel="noopener noreferrer" className="about-edr__item">
                            <img src="/docs/edr2.png" alt="Виписка з ЄДР — сторінка 2" className="about-edr__img" />
                            <span className="about-edr__caption">Сторінка 2</span>
                        </a>
                    </div>
                </section>

                <section className="about-section">
                    <h2 className="about-section__title">Реквізити</h2>
                    <div className="about-company">
                        {requisites.map(({ label, value }) => (
                            <div key={label} className="about-company__row">
                                <span className="about-company__label">{label}</span>
                                <span className="about-company__value">{value}</span>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
        </Layout>
    );
};

export default AboutPage;
